import { Polygon, Layer } from '../../../context/context';

export interface PolygonStyleHandlerProps {
    polygon: Polygon;
    global: {
        mapLayers: Layer[];
        activeLayerId: number | null;
    };
    editLayer: (updatedLayer: Layer, layerId: number) => void;
    setSelectedPolygon: (polygon: Polygon | null) => void;
    setIsPolygonModalOpen: (open: boolean) => void;
}

export function handlePolygonStyleEdit({
    polygon,
    global,
    editLayer,
    setSelectedPolygon,
    setIsPolygonModalOpen
}: PolygonStyleHandlerProps) {
    const { activeLayerId, mapLayers } = global;
    console.log('handlePolygonStyleEdit called with:', { 
        polygonId: polygon.id, 
        activeLayerId, 
        mapLayersCount: mapLayers.length,
        polygonColour: polygon.colour,
        polygonBorderColour: polygon.borderColour
    });
    
    const layer = mapLayers.find(l => l.layerId === activeLayerId);
    console.log('Found layer:', layer);
    
    if (layer && activeLayerId !== null) {
        const updatedShapes = layer.shapes.map(shape =>
            shape.id === polygon.id ? polygon : shape
        );

        const updatedLayer = {
            ...layer,
            shapes: updatedShapes
        };

        console.log('Updating layer with new polygon:', updatedLayer);
        editLayer(updatedLayer, activeLayerId);
        setSelectedPolygon(null);
        setIsPolygonModalOpen(false);
        console.log('Polygon style edit completed');
    } else {
        console.error('Could not find layer or activeLayerId is null:', { activeLayerId, layer });
    }
} 